import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../../../../styles/dashboardTheme.css";
import "../../../../styles/managementTheme.css";
import "../styles/rrhh.css";
import EmpleadosSummary from "../components/EmpleadosSummary";
import EmpleadosFilters from "../components/EmpleadosFilters";
import EmpleadosTable from "../components/EmpleadosTable";
import EmpleadoFormModal from "../components/EmpleadoFormModal";
import { usePermissions } from "../../../../utils/permissions";
import { isModuloHabilitado } from "../../../../utils/modulosSistema";
import ImportarDocentesModal from "../components/ImportarDocentesModal";

export default function EmpleadosView({
  loading, error, resumen,
  filtros, setFiltros, limpiarFiltros,
  lastUpdated,
  page, pageSize, setPageSize, totalPages, total, goToPage,
  empleadosPaginados,
  seleccionado, seleccionar,
  reload, upsertEmpleado, form,
}) {
  const { hasPermission } = usePermissions();
  const canCreate = hasPermission("rrhh.empleados.crear");
  const canUpdate = hasPermission("rrhh.empleados.editar");
  const canDelete = hasPermission("rrhh.empleados.eliminar");
  const showSync  = isModuloHabilitado("integracion_contifico");

  useEffect(() => {
    if (typeof document === "undefined") return undefined;
    if (form.modal) document.body.classList.add("modal-open");
    else document.body.classList.remove("modal-open");
    return () => document.body.classList.remove("modal-open");
  }, [form.modal]);

  const quickFilter = (key) => {
    switch (key) {
      case "activos":         setFiltros((p) => ({ ...p, estado: "activo",   tipo_personal: "all" })); break;
      case "docentes":        setFiltros((p) => ({ ...p, tipo_personal: "docente",        estado: "all" })); break;
      case "administrativos": setFiltros((p) => ({ ...p, tipo_personal: "administrativo", estado: "all" })); break;
      case "servicios":       setFiltros((p) => ({ ...p, tipo_personal: "servicios",      estado: "all" })); break;
      case "enNomina":        setFiltros((p) => ({ ...p, tipo_contratacion: "nomina",    estado: "all", tipo_personal: "all" })); break;
      case "porServicios":    setFiltros((p) => ({ ...p, tipo_contratacion: "servicios", estado: "all", tipo_personal: "all" })); break;
      default:                limpiarFiltros(); break;
    }
  };

  const activeQuickFilter =
    filtros.tipo_personal !== "all" ? filtros.tipo_personal :
    filtros.tipo_contratacion === "nomina" ? "enNomina" :
    filtros.tipo_contratacion === "servicios" ? "porServicios" :
    filtros.estado === "activo" ? "activos" : "total";

  const lastSync = lastUpdated ? lastUpdated.toLocaleString() : "Sincronización inicial";

  return (
    <section className="management-page management-theme-blue rrhh-wrapper">
      <div className="management-card management-header mb-4">
        <div>
          <p className="management-eyebrow mb-1">RRHH / Empleados</p>
          <h4 className="management-title mb-1 d-flex align-items-center gap-2">
            <i className="bi bi-people" />
            Gestión de empleados
          </h4>
          <p className="text-muted mb-0">
            Administra el personal del centro: docentes, administrativos y servicios.
          </p>
        </div>
        <div className="d-flex flex-column align-items-end gap-2">
          <div className="d-flex gap-2">
            {canCreate && (
              <button type="button" className="btn btn-outline-primary btn-sm" onClick={() => form.setModalImportar(true)}>
                <i className="bi bi-download me-2" />
                Importar docentes
              </button>
            )}
            {canCreate && (
              <button type="button" className="btn management-btn-primary" onClick={form.abrirCrear}>
                <i className="bi bi-person-plus me-2" />
                Nuevo empleado
              </button>
            )}
          </div>
          <small className="text-muted">Actualizado: {lastSync}</small>
        </div>
      </div>

      <EmpleadosSummary resumen={resumen} onQuickFilter={quickFilter} activeKey={activeQuickFilter} />

      <EmpleadosFilters filtros={filtros} setFiltros={setFiltros} limpiarFiltros={limpiarFiltros} />

      <EmpleadosTable
        empleados={empleadosPaginados}
        loading={loading}
        error={error}
        seleccionadoId={seleccionado?.id}
        onSelect={seleccionar}
        onEdit={canUpdate ? form.abrirEditar : undefined}
        onDelete={canDelete ? form.abrirEliminar : undefined}
        canEdit={canUpdate}
        canDelete={canDelete}
        showSync={showSync}
        reload={reload}
        onSynced={(emp, res) => upsertEmpleado({
          ...emp,
          contificoPersonaId: res.contifico_persona_id,
          ruc: res.ruc || emp.ruc,
        })}
      />

      <div className="management-card d-flex justify-content-between align-items-center flex-wrap gap-3">
        <div className="text-muted small">
          Mostrando {total === 0 ? 0 : (page - 1) * pageSize + 1}–{Math.min(total, page * pageSize)} de {total}
        </div>
        <div className="d-flex align-items-center gap-2 flex-wrap">
          <select
            className="form-select form-select-sm"
            value={pageSize}
            onChange={(e) => { setPageSize(Number(e.target.value) || 10); goToPage(1); }}
          >
            {[10, 25, 50].map((s) => <option key={s} value={s}>{s} por página</option>)}
          </select>
          <div className="btn-group">
            <button className="btn btn-outline-secondary btn-sm" onClick={() => goToPage(page - 1)} disabled={page <= 1}>
              <i className="bi bi-chevron-left" />
            </button>
            <button className="btn btn-outline-secondary btn-sm" disabled>
              Página {page} / {totalPages}
            </button>
            <button className="btn btn-outline-secondary btn-sm" onClick={() => goToPage(page + 1)} disabled={page >= totalPages}>
              <i className="bi bi-chevron-right" />
            </button>
          </div>
        </div>
      </div>

      <EmpleadoFormModal {...form} />

      <ImportarDocentesModal
        open={form.modalImportar}
        onClose={() => form.setModalImportar(false)}
        onImportado={reload}
      />
    </section>
  );
}
